module.exports = __webpack_public_path__ + "static/media/login_logo.4cdbe202.svg";